<template>
  <b-col cols="12" sm="12">
    <div>
      <b-btn class="mb-3 d-flex align-items-center text-white" :variant="isSidebarVisible ? undefined : 'info'"
        @click="openForm">
        <feather type="alert-circle" class="feather-sm mr-2"></feather>
        {{ isSidebarVisible ? 'Cerrar formulario' : $t("vGeocercas.verForm") }}
      </b-btn>
    </div>

    <div class="map-wrapper-scaling">
      <mapa ref="map" :options="options" @geoData="getlatlngGeofence"></mapa>
    </div>

    <panel-component id="sidebar-form" :visible.sync="isSidebarVisible">
      <div style="color: #54606f;">
        <span style="font-weight: 400;">* {{ this.$t("Gral.camposObligatorios") }}</span>
        <b-col cols="12" sm="12">
          <b-form-group>
            <label for="“nombre”">{{ this.$t("Gral.nombre") }}: <strong>*</strong></label>
            <b-form-input id="nombre" v-model="geofence.nombre" required>
            </b-form-input>
          </b-form-group>
          <div v-if="isCircleGeofence" class="row">
            <b-col cols="12" sm="6">
              <b-form-group id="input-group-2" :label="$t('Gral.medida') + ':'">
                <b-form-select id="distancia" v-model="settingsDistance.distanceUnit" :options="translateUnitDistance">
                  <template #first>
                    <b-form-select-option :value="null" disabled>
                      {{ $t("vGeocercas.selectMedida") }}
                    </b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6">
              <label for="“radio”">{{ this.$t("Gral.radio") }}: <strong>*</strong></label>
              <b-form-input type="number" step="0.001" min="1" max="1000" id="radioV" v-model="settingsDistance.radius">
              </b-form-input>
            </b-col>
            <b-col cols="12" sm="12" style="margin-top: -16px">
              <label for="“latitud”">{{ this.$t("Gral.latitud") }}: <strong>*</strong></label>
              <b-form-input id="latitud" type="number" step="0.00000001" max="90" min="-90" v-model="geofence.latitud">
              </b-form-input>
            </b-col>
            <b-col cols="12" sm="12">
              <label for="“longitud”">{{ this.$t("Gral.longitud") }}: <strong>*</strong></label>
              <b-form-input id="longitud" type="number" step="0.00000001" max="180" min="-180"
                v-model="geofence.longitud">
              </b-form-input>
            </b-col>
          </div>
          <div class="row">
            <b-col cols="12" sm="6">
              <label for="“pick-color”">Color: <strong>*</strong></label>
              <b-form-input id="pick-color" type="color" v-model="geofence.color">
              </b-form-input>
            </b-col>
            <b-col cols="12" sm="6">
              <label for="“latitud”">{{ this.$t("Gral.alerta") }}: <strong>*</strong></label>
              <b-form-select v-model="geofence.alerta" :options="translateTypeAlerts" required>
                <template #first>
                  <b-form-select-option :value="null" disabled>
                    {{ $t("vGeocercas.selectAlert") }}
                  </b-form-select-option>
                </template>
              </b-form-select>
            </b-col>
            <b-col cols="12" sm="12">
              <label for="asignarDispo">{{ this.$t("vGeocercas.lblAsigDispo") }}:</label>
              <multiselect id="asignarDispo" v-model="geofence.dispositivos" :options="devices" :multiple="true"
                :selectLabel="$t('vHistorico.presioneAgregar')" :selectedLabel="$t('vHistorico.seleccionado')"
                :deselectLabel="$t('vHistorico.presioneEliminar')" :placeholder="$t('Gral.escribaBuscar')"
                track-by="nombre" label="nombre">
                <span slot="noResult">{{ this.$t("vHistorico.msgBusquedaFallida") }}</span>
              </multiselect>
            </b-col>

            <b-col cols="12">
              <b-btn class="mt-1 w-100 text-white" variant="info" :pressed.sync="isNewGeofence"
                @click="registrarGeocerca">
                {{ this.$t("Gral.guardarCont") }}
              </b-btn>
            </b-col>
            <b-col cols="12" style="margin-top: -20px">
              <b-btn class="mt-1 w-100 text-light" color="primary" @click="returnToGeofences">
                {{ this.$t("Gral.cancelar") }}
              </b-btn>
            </b-col>
            <b-col cols="12" style="margin-top: -20px">
              <b-btn class="mt-1 w-100 text-white" variant="info" @click="registrarGeocerca">
                {{ this.$t("vGeocercas.saveGeocercas") }}
              </b-btn>
            </b-col>
          </div>
        </b-col>
      </div>
    </panel-component>
  </b-col>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import AccionesDataService from "../../../services/AccionesDataService";
import Crypto from '../../../services/Crypto';
import DevicesDataService from "../../../services/DevicesDataService";
import GeocercaDataService from "../../../services/GeocercaDataService";

import { generalSweetAlert } from '../../../utils/Utils';
import Mapa from "./../../components/Map";
import Multiselect from "vue-multiselect";
import PanelComponent from './../../components/PanelComponent';


export default {
  name: "add-Geocerca",
  components: {
    Mapa,
    PanelComponent,
    Multiselect,
  },
  data() {
    return {
      options: {
        useDrawTools: true,
      },
      isSidebarVisible: false,
      geofence: {
        alerta: null,
        color: "#000000",
        dispositivos: [],
        latitud: 0,
        locate: null,
        longitud: 0,
        nombre: '',
        radio: 0,
        usuario: null,
      },
      isCircleGeofence: true,
      settingsDistance: {
        distanceUnit: null,
        radius: "",
      },
      distanceUnit: [
        { text: "km", value: "Kilómetros." },
        { text: "metros", value: "Metros." },
      ],
      typeAlerts: [
        { text: "ambos", value: "Ambos" },
        { text: "entrada", value: "Entrada" },
        { text: "salida", value: "Salida" },
      ],
      key: '',
      devices: [],
      geofenceLayer: null,
      isNewGeofence: false,
    }
  },
  computed: {
    translateUnitDistance() {
      return this.translateOptions(this.distanceUnit)
    },
    translateTypeAlerts() {
      return this.translateOptions(this.typeAlerts);
    }
  },
  mounted() {
    this.key = sessionStorage.getItem('key')
    this.getDevices();
    this.$nextTick(() => {
      this.$refs.map.locateControl.start();
    });
  },
  methods: {
    openForm() {
      this.isSidebarVisible = !this.isSidebarVisible;
    },
    translateOptions(values) {
      return values.map((option) => {
        if (typeof option === "object" && option.text) {
          return {
            ...option,
            text: this.$t(`vGeocercas.${option.text}`),
          };
        }
      });
    },
    /** Método para obtener todos los dispositivos. */
    async getDevices() {
      try {
        const response = await DevicesDataService.getAll();
        this.devices = await Crypto.desencriptar(response.data, this.key);
      } catch (error) {
        console.log(error);
      }
    },
    getlatlngGeofence(latlng) {
      this.isSidebarVisible = true;
      this.updateGeofenceCoordinates(latlng);
      this.updateGeofenceStyle(latlng);
      this.setupColorChangeListener();
    },

    updateGeofenceCoordinates(latlng) {
      if (latlng.type === 'Point') {
        this.geofence.latitud = latlng.coordinates[1];
        this.geofence.longitud = latlng.coordinates[0];
        this.settingsDistance.radius = latlng.radiusConfig.radius;
        this.geofence.coordinates = latlng.coordinates;
        this.setDistanceUnit(latlng.radiusConfig.unit);
      } else {
        this.geofence.coordinates = latlng.coordinates;
        this.isCircleGeofence = false;
      }
      this.geofence.tipo = latlng.type;
      this.geofence.layer = latlng.layer;
    },
    setDistanceUnit(unit) {
      const distanceElement = document.getElementById("distancia");
      if (unit === 'meters') distanceElement.value = "Metros.";
      else if (unit === 'km') distanceElement.value = "Kilómetros.";
    },
    updateGeofenceStyle(latlng) {
      const color = document.getElementById("pick-color").value;
      latlng.layer.setStyle({ color });
    },
    setupColorChangeListener() {
      const pickColor = document.getElementById("pick-color");
      pickColor.addEventListener("input", this.handleColorChange, false);
    },
    handleColorChange() {
      const color = document.getElementById("pick-color").value;
      if (this.geofence.layer) {
        this.geofence.layer.setStyle({ color });
        this.geofenceLayer = this.geofence.layer;
      }
    },

    async registrarGeocerca() {
      let radio = 0;
      if (this.geofence.tipo === 'Point') {
        radio = this.settingsDistance.radius;
        const distancia = document.getElementById("distancia").value;
        if (distancia !== "Metros.") radio = radio * 1000;
      }

      let data = {
        nombre: this.geofence.nombre,
        color: this.geofence.color,
        alerta: this.geofence.alerta,
        dispositivos: this.geofence.dispositivos,
        habilitado: true,
        ...(this.geofence.tipo === 'Point' && { radio, latitud: this.geofence.latitud, longitud: this.geofence.longitud }),
        locate: {
          type: this.geofence.tipo,
          coordinates: this.geofence.coordinates,
          ...(this.geofence.tipo === 'Point' && { properties: { radius: radio } }),
        }
      }

      try {
        await GeocercaDataService.create(data, this.key);
        const accion = "Creó la geocerca " + data.nombre;
        this.registrarAccion(accion);
        generalSweetAlert(this.$t("vGeocercas.msgGeoRegistrada"), 'success');
        this.isNewGeofence ? this.resetGeofenceForm() : this.returnToGeofences();
      } catch (error) {
        console.error(error);
        generalSweetAlert(this.$t("vGeocercas.msgErrGeoReg"), 'error');
      }
    },
    resetGeofenceForm() {
      this.geofence = {
        alerta: null,
        color: '#000000',
        dispositivos: [],
        latitud: 0,
        locate: null,
        longitud: 0,
        nombre: '',
        radio: 0,
        usuario: null,
      };
      this.settingsDistance = {};
      this.$refs.map.removeEntityFromMap(this.geofenceLayer);
      this.isNewGeofence = false;
      this.isSidebarVisible = false;
    },
    registrarAccion(accion) {
      let data = {
        usuario: JSON.parse(sessionStorage.getItem("usuarioLogueado")),
        accion: accion + sessionStorage.infoDevice,
        fechaCreacion: new Date(),
        tipo: "accion",
      };
      AccionesDataService.create(data, this.key);
    },
    returnToGeofences() {
      this.$router.push("/geocercas");
    }
  },
}
</script>

<style>
/* Contenedor del mapa para que sea dinámico */
.map-wrapper-scaling {
  width: 100%;
  height: 65vh;
  /* Ocupa el 65% del alto de la pantalla */
  min-height: 500px;
  margin-top: 15px;
  margin-bottom: 15px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #ddd;
}
</style>